import * as React from 'react'
import axios from 'axios'
import Navbar from './Navbar'
import { Container, Grid2, TextField, Button, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { login } from '../../features/auth/authSlice'
import { getCompanyData } from '../../features/setup/useableSlice'

const SignUp = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { user } = useSelector(state => state.auth)

    React.useEffect(() => {
        if (user) {
            navigate('/DashBaord')
        }
    }, [user, navigate])

    React.useEffect(() => {
        dispatch(getCompanyData())
            .then((res) => {
                if (res.payload.length > 0) {
                    navigate('/Login')
                }
            })
    })
    const [file, setFile] = React.useState(null);
    const [cmpData, setCmpData] = React.useState({
        cmpName: '', cmpAddress: '', cmpEmail: '', cmpContact: ''
    })
    const onFileChange = (e) => {
        console.log(e.target.files[0])
        setFile(e.target.files[0]);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('cmpImage', file);
        formData.append('cmpName', cmpData.cmpName);
        formData.append('cmpAddress', cmpData.cmpAddress);
        formData.append('cmpEmail', cmpData.cmpEmail);
        formData.append('cmpContact', cmpData.cmpContact);

        try {
            console.log(formData);
            const res = await axios.post('http://localhost:5000/company/addcompany', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(dispatch(login({ userName: cmpData.userName, userPassword: cmpData.userPassword })))
                .then(navigate('/'))
            console.log(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCmpData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        console.log(cmpData)
    };

    return (
        <>
            <Navbar />
            <Container component="main" maxWidth="xs">
                <Grid2 container spacing={2} marginBottom={5}>
                    <Grid2 size={12}>
                        <TextField id="cmpName" label="Company Name" variant="outlined" fullWidth name='cmpName' onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <TextField id="cmpAddress" label="Company Address" variant="outlined" fullWidth name='cmpAddress' onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <TextField id="cmpEmail" label="Company E-Mail" variant="outlined" fullWidth name='cmpEmail' onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <TextField id="cmpContact" label="Company Contact" variant="outlined" fullWidth name='cmpContact' onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <input
                            accept="image/*"
                            style={{ display: 'none' }}
                            id="raised-button-file"
                            multiple
                            type="file"
                            onChange={onFileChange}
                        />
                        <label htmlFor="raised-button-file">
                            <Button
                                variant="contained"
                                component="span"
                                fullWidth >
                                Company Image
                            </Button>
                        </label>

                    </Grid2>
                    <Grid2 size={12}>
                        <Button variant="contained" fullWidth onClick={onSubmit}>ADD</Button>
                    </Grid2>
                    <Grid2 size={12}><Typography onClick={() => { navigate('/Login') }} sx={{ color: 'grey', cursor: 'pointer', textAlign: 'right' }} >Already Have Account? Please Sign In!...</Typography></Grid2>
                </Grid2>
            </Container>
        </>
    )
}

export default SignUp